const hrPage = () => import('@/pages/hrPage')
const testPage = () => import('@/pages/testPage')
const field = () => import('@/pages/demo/field-demo')

export default [{
  path: '/hrPage',
  name: 'hrPage',
  component: hrPage,
  meta: {}
},
{
  path: '/demo/field',
  name: '/demo/field',
  component: field,
  meta: {}
},
{
  path: '/dst/testPage',
  name: '/dst/testPage',
  component: testPage,
  meta: {}
}

]



// WEBPACK FOOTER //
// ./src/router/demo/index.js